// extracted by mini-css-extract-plugin
export default {"root":"animated_waiting_icon_root__uJVl1","loader":"animated_waiting_icon_loader__4p7ez","rotation":"animated_waiting_icon_rotation__QmThQ"};